module.exports = __webpack_public_path__ + "img/error-404page.b5b353e7.svg";